



















import { Vue, Component } from 'vue-property-decorator';
import { LocalNewsItem, NewsList } from 'src/types/views/home';
import { getNewsList } from 'service/api';

@Component
export default class NewsListComponent extends Vue {
  newsList: LocalNewsItem[] = [];

  async getNewsList() {
    const res = await getNewsList();
    if ((res as NewsList).code === 200) {
      this.newsList = (res as NewsList).data.rows.map(item => ({
        title: item.title,
        url: item.img_url,
        id: item.id,
      }));
    }
  }

  mounted() {
    this.getNewsList();
  }
}
